<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12"
                 v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择"
                        default-value
                        v-model="query.tenantId"
                        allow-clear>
                <a-select-option v-for="item in tenantList"
                                 :key="item.tenantId"
                                 :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
                <a-select-option v-for="item in tenantList"
                                 :key="item.tenantId"
                                 :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="位置">
              <a-input v-model="query.address"
                       placeholder="请输入位置"
                       allow-clear />
            </a-form-item>
          </a-col>
          <!--          <a-col :md="6" :sm="12">-->
          <!--            <a-form-item label="状态">-->
          <!--              <a-select v-model="query.status" placeholder="请选择状态" allow-clear>-->
          <!--                <a-select-option :value="0">正常</a-select-option>-->
          <!--                <a-select-option :value="1">异常</a-select-option>-->
          <!--              </a-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :md="6"
                 :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="addOrUpdateHandle()">新增</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow()">删除</a-button>
              <a-button type="primary"
                        style="margin-left: 8px"
                        @click="Oneclick()">一键同步</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             @change="pageChange">
      <span slot="action"
            slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)">编辑</a>
        <!-- <a-divider type="vertical" /> -->
        <!-- <a @click="showLineLayer(record)">展示线</a> -->
      </span>
      <span slot="createTime"
            slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
      <span slot="typeAction"
            slot-scope="text">
        <a-tag v-if="text === 1"
               color="#0c89ef">出厂水</a-tag>
        <a-tag v-if="text === 0"
               color="#125da3">原水</a-tag>
        <a-tag v-if="text === 2"
               color="rgb(45, 183, 245)">管网末梢水</a-tag>
      </span>
    </a-table>
    <a-modal title="操作"
             style="top: 20px"
             :width="800"
             v-model="addOrUpdateVisible"
             @ok="handleOk"
             @cancel="handleCancel">
      <a-form class="log-form"
              :form="addOrUpdateForm">
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="位置">
          <a-input placeholder="位置"
                   v-decorator="['address', { rules: [{ required: true, message: '请输入位置' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="时间">
          <a-input placeholder="时间(格式： 21:00)"
                   v-decorator="['time', { rules: [{ required: true, message: '请输入时间' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="浊度NTU">
          <a-input placeholder="浊度NTU"
                   v-decorator="['turbidity', { rules: [{ required: true, message: '请输入浊度' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="类型">
          <a-select v-decorator="['type', { rules: [{ required: true, message: '请选择类型' }] }]">
            <a-select-option :value="1">出厂水</a-select-option>
            <a-select-option :value="0">原水</a-select-option>
            <a-select-option :value="2">管网末梢水</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="余氯mg/L">
          <a-input placeholder="余氯mg/L"
                   v-decorator="['chlorine', { rules: [{ required: true, message: '余氯mg/L' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="PH">
          <a-input placeholder="PH"
                   v-decorator="['ph', { rules: [{ required: true, message: 'PH' }] }]" />
        </a-form-item>
        <a-form-item :labelCol="labelCol"
                     :wrapperCol="wrapperCol"
                     label="是否同步">
          <a-radio-group v-decorator="['isType', { rules: [{ required: true, message: '是否同步' }] }]">
            <a-radio :value="1">同步</a-radio>
            <a-radio :value="0">不同步</a-radio>
          </a-radio-group>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 同步 -->
    <a-modal title="同步"
             :width="800"
             v-model="Visible"
             @ok="OneOk"
             @cancel="Visible = false">
      <a-form-model class="log-form"
                    :model="UpdateForm"
                    ref="UpdateForm"
                    :rules="rules">
        <a-form-model-item label="是否同步时间"
                           prop="isType"
                           :label-col="{ span: 9 }"
                           :wrapper-col="{ span: 15 }">
          <a-radio-group v-model="UpdateForm.isType">
            <a-radio :value="1">同步</a-radio>
            <a-radio :value="0">不同步</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
const columns = [
  {
    title: '位置',
    dataIndex: 'address'
  },
  {
    title: '浊度NTU',
    dataIndex: 'turbidity'
  },
  {
    title: '余氯mg/L',
    dataIndex: 'chlorine'
  },
  {
    title: 'PH',
    dataIndex: 'ph'
  },
  {
    title: '类型',
    dataIndex: 'type',
    scopedSlots: { customRender: 'typeAction' }
  },
  {
    title: '时间',
    dataIndex: 'time'
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'WaterQuality',
  data () {
    return {
      currentId: '',
      queryUrl: '/pipe-network/water_quality/page',
      deleteUrl: '/pipe-network/water_quality',
      addOrUpdateUrl: '/pipe-network/water_quality',
      queryOneUrl: '/pipe-network/water_quality',
      mapVisible: false,
      Visible: false,
      UpdateForm: {
        isType: 0
      },
      query: {
        address: '',
        tenantId: this.$store.state.user.info.tenantId
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created () {
    this.getAllTenant()
  },
  computed: {
    rules () {
      return {
        isType: [{ required: true, message: '是否同步时间', trigger: 'change' }]
      }
    }
  },
  methods: {
    Oneclick () {
      this.Visible = true
    },
    OneOk () {
      this.$refs.UpdateForm.validate((valid) => {
        if (valid) {
          this.$http.put('/pipe-network/water_quality/one/click', { ...this.UpdateForm }).then((res) => {
            if (res.code == 0) {
              this.$message.success(`操作成功`)
              this.queryList()
              this.Visible = false
            } else {
              this.$message.success(`操作失败！`)
              this.queryList()
              this.Visible = false
            }
          })
        }
      })
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}
</style>
